export const geocodeAddress = (address: string) => {
  if (!window.google?.maps?.Geocoder) return Promise.resolve(undefined)

  return new Promise<google.maps.GeocoderResult | undefined>(resolve => {
    new window.google.maps.Geocoder().geocode({ address }, results => {
      resolve(results?.[0])
    })
  })
}
